import axios from 'axios';
import getApiUrl from '../helpers/apiUrls'
import { authHeader } from '../helpers/authHeader';
import * as commonActions from '../store/common/actions'
import * as actions from './../store/quote/actions'
import * as shipmentActions from '../store/shipment/actions'
import * as type from '../store/quote/actionTypes'
import utilCommon from '../helpers/utilCommon'
import { templates } from '../helpers/templates';
import lodash from "lodash";
import { setLoader } from './../store/quote/actions'
import {getShipmentDetail} from "./shipmentService";

let activeQuoteRequests = [];
let activeQuoteInterval = null;
let cancelRequested = false;

export const getQuotesMaster = (dispatch, lang, dictionaries) => {
    const params = { headers: authHeader() };
    const url = getApiUrl('quote', 'getFaciltyTypes');
    dispatch(commonActions.setLoader(true))
    axios.get(url, params)
        .then((response) => {
            dispatch(commonActions.setLoader(false))
            if (response.data.success) {
                dispatch({ type: type.SET_FACILITY_TYPES, facilityTypes: response.data.content.facilityTypeAccessorialsList })
            }
        })
        .catch((err) => {
            dispatch(commonActions.setLoader(false))
        });

    const url1 = getApiUrl('quote', 'customerMaster');
    dispatch(commonActions.setLoader(true))
    axios.get(url1, params)
        .then((response) => {
            dispatch(commonActions.setLoader(false))
            if (response.data.success) {
                dispatch({ type: type.SET_MASTER_DATA, master: response.data.content.compositeCustomerDataList })
            }
        })
        .catch((err) => {
            dispatch(commonActions.setLoader(false))
        });

};


// get Products
export const getProducts = (dispatch, lang, dictionary) => {
    const params = { headers: authHeader() };
    dispatch(commonActions.setLoader(true))
    const url = getApiUrl('quote', 'getProducts')
    axios.get(url, params)
        .then((response) => {
            dispatch(commonActions.setLoader(false))
            if (response.data.success) {
                dispatch({ type: type.SET_CUSTOMER_PRODUCTS, products: response.data.content.customerProductList })
            } else {
                response.data.errors.map((error) => {
                    utilCommon.showNotification(error, dictionary, lang)
                })
            }
        })
        .catch((err) => {
            dispatch(commonActions.setLoader(false))
        });
};


// get Products
export const getAddresses = (dispatch, lang, dictionary, inputDTO={}) => {
    const params = { headers: authHeader() };
    dispatch(commonActions.setLoader(true))
    const url = getApiUrl('customer', 'address')
    axios.get(url, params)
        .then((response) => {
            if (lodash.get(inputDTO, 'stopLoader', true)) dispatch(commonActions.setLoader(false));
            if (response.data.success) {
                dispatch({ type: type.SET_CUSTOMER_ADDRESS, addresses: response.data.content.customerAddressList })
            } else {
                response.data.errors.map((error) => {
                    utilCommon.showNotification(error, dictionary, lang)
                })
            }
        })
        .catch((err) => {
            dispatch(commonActions.setLoader(false))
        });
};

export const cancelQuoteRequests = (dispatch = null) => {
    console.log('cancelQuoteRequests')
    // cancelRequested = true;
    //
    // activeQuoteRequests.forEach(source => {
    //     try {
    //         if (source && typeof source.cancel === 'function') {
    //             source.cancel('Cancelled due to navigation');
    //         }
    //     } catch (e) {}
    // });
    //
    // activeQuoteRequests = [];
    //
    // if (activeQuoteInterval) {
    //     clearInterval(activeQuoteInterval);
    //     activeQuoteInterval = null;
    // }
    //
    // if (dispatch) {
    //     dispatch({ type: 'SET_LOADER', flag: false });
    // }
};

export const getQuoteResults = (lang, dictionaries, inputDTO) => (dispatch, getState) => {
    cancelRequested = false;

    const params = { headers: authHeader() };
    const url = getApiUrl('quote', 'getQuoteResults');

    dispatch(actions.setQuoteResults({
        quoteResults: [],
        quoteRequestUuid: {},
        loading: true,
        progress: 0,
        progressBar: true
    }));

    dispatch(shipmentActions.setTransactionDetail([]))

    const quoteResultsTemplate = lodash.get(getState().accountInfo, 'customerState.preference.quoteResultsTemplate', 'Full');
    const template = parseInt(lodash.get(getState().accountInfo, 'customerState.customerShippingFrequency.id', 1).toString());

    const filterResults = (results) => {
        let carriers = [];
        let items = [];
        results.forEach(item => {
            if (!carriers.includes(item.FCcarrierName)) {
                carriers.push(item.FCcarrierName);
                items.push(item);
            }
        });
        return items;
    };

    if (quoteResultsTemplate !== 'Full') {
        const CancelToken = axios.CancelToken;
        const source = CancelToken.source();
        activeQuoteRequests.push(source);

        axios.post(url, inputDTO, { ...params, cancelToken: source.token })
            .then(response => {
                if (cancelRequested) return;
                const quoteResults = {
                    quoteResults: response.data.content.responseData.rateQuotes,
                    quoteRequestUuid: {"Default": response.data.quoteRequestUuid},
                    template: response.data.content.responseData.template ? response.data.content.responseData.template : templates.full,
                    loading: false
                };
                dispatch(actions.setQuoteResults(quoteResults));
                templates.handleTemplateRoute(template, Window['history']);
            })
            .catch(error => {
                if (axios.isCancel(error)) {
                    console.log('Quote request cancelled');
                } else {
                    console.log('QUOTE FETCH ERROR', error);
                }
            });
    } else {
        let counter = 0;
        const capacityProviderAccountGroups = ['A4', 'B4', 'C6', 'D10'];
        let results = {
            quoteResults: [],
            quoteRequestUuid: {},
            template: templates.full,
            loading: true,
            progress: 0,
            progressBar: true
        };

        capacityProviderAccountGroups.forEach(code => {
            const CancelToken = axios.CancelToken;
            const source = CancelToken.source();
            activeQuoteRequests.push(source);

            const payload = {
                capacityProviderAccountGroup: { code },
                ...inputDTO,
                apiConfiguration: {
                    ...inputDTO.apiConfiguration,
                    timeout: parseInt(code.replace(/\D/, ''))
                }
            };

            axios.post(url, payload, { ...params, cancelToken: source.token })
                .then(response => {
                    if (cancelRequested) return;

                    counter++;
                    results = {
                        quoteResults: filterResults(lodash.union(results.quoteResults, response.data.content.responseData.rateQuotes)),
                        quoteRequestUuid: { ...results.quoteRequestUuid, [code]: response.data.quoteRequestUuid },
                        template: response.data.content.responseData.template ? response.data.content.responseData.template : templates.full,
                        loading: counter !== capacityProviderAccountGroups.length,
                        progress: counter / capacityProviderAccountGroups.length * 100,
                        progressBar: true
                    };
                })
                .catch(error => {
                    if (axios.isCancel(error)) {
                        console.log('Cancelled:', code);
                    } else {
                        console.log('QUOTE FETCH ERROR', error);
                    }
                    counter++;
                    results = {
                        ...results,
                        loading: counter !== capacityProviderAccountGroups.length,
                        progress: counter / capacityProviderAccountGroups.length * 100
                    };
                });
        });

        activeQuoteInterval = setInterval(() => {
            if (cancelRequested) return;

            dispatch(actions.setQuoteResults(results));

            if (counter === capacityProviderAccountGroups.length) {
                clearInterval(activeQuoteInterval);
                activeQuoteInterval = null;

                setTimeout(() => {
                    dispatch(actions.setQuoteResults({ ...results, progressBar: false }));
                }, 1000);

                dispatch(setLoader(false));
            }
        }, 1000);

        templates.handleTemplateRoute(template, Window['history']);
    }
};

export const getCarriers = (dispatch, lang, dictionaries) => {
    const params = { headers: authHeader() };
    const url = getApiUrl('quote', 'getCarriers');
    dispatch(commonActions.setLoader(true))
    axios.get(url, params)
        .then((response) => {
            dispatch(commonActions.setLoader(false))
            if (response.data.success) {
                dispatch({ type: type.SET_CARRIERS, carriers: response.data.content.carrierList })
            }
        })
        .catch((err) => {
            dispatch(commonActions.setLoader(false))
        });

};

export const createShipment = (dispatch, currentLanguage, dictionary, inputDTO) => {
    const params = { headers: authHeader() };
    const url = getApiUrl('quote', 'createShipment');
    inputDTO = utilCommon.addGoogleAdsId(inputDTO);
    dispatch(commonActions.setLoader(true))
    axios.post(url, inputDTO, params)
        .then((response) => {
            dispatch(commonActions.setLoader(false))
            if (response.data.success) {
                utilCommon.showNotification('Shipment created successfully', dictionary, currentLanguage)
                Window['history'].push('/customer/shipment',{shipmentUuid:response.data.content.shipmentUuid})
            } else {
                response.data.errors.map((error) => {
                    utilCommon.showNotification(error, dictionary, currentLanguage)
                })
            }
        })
        .catch((err) => {
            dispatch(commonActions.setLoader(false))
        });
};

export const fcCreateShipment = (dispatch, currentLanguage, dictionary, inputDTO) => {
    const params = { headers: authHeader() };
    const url = getApiUrl('quote', 'fcCreateShipment');
    inputDTO = utilCommon.addGoogleAdsId(inputDTO);
    dispatch(commonActions.setLoader(true))
    axios.post(url, inputDTO, params)
        .then((response) => {
            dispatch(commonActions.setLoader(false))
            if (response.data.success) {
                utilCommon.showNotification('Shipment created successfully', dictionary, currentLanguage)
                Window['history'].push('/customer/shipment',{shipmentUuid:response.data.content.shipmentUuid})
            } else {
                response.data.errors.map((error) => {
                    utilCommon.showNotification(error, dictionary, currentLanguage)
                })
            }
        })
        .catch((err) => {
            dispatch(commonActions.setLoader(false))
        });
};


// rerun quote
export const reRunQuote = (dispatch, currentLanguage, dictionary, inputDTO) => {
    const params = { headers: authHeader() };
    const url = getApiUrl('quote', 'reRunQuote');
    dispatch(commonActions.setLoader(true))
    axios.put(url, inputDTO, params)
        .then((response) => {
            dispatch(commonActions.setLoader(false))
            if (response.data.success) {
                utilCommon.showNotification('Shipment created successfully', dictionary, currentLanguage)
                Window['history'].push('/customer/shipment',{shipmentUuid:response.data.content.shipmentUuid})
            } else {
                response.data.errors.map((error) => {
                    utilCommon.showNotification(error, dictionary, currentLanguage)
                })
            }
        })
        .catch((err) => {
            dispatch(commonActions.setLoader(false))
        });
};

// rerun quote
export const fcReRunQuote = (dispatch, currentLanguage, dictionary, inputDTO) => {
    const params = { headers: authHeader() };
    const url = getApiUrl('quote', 'fcReRunQuote');
    dispatch(commonActions.setLoader(true))
    axios.put(url, inputDTO, params)
        .then((response) => {
            dispatch(commonActions.setLoader(false))
            if (response.data.success) {
                utilCommon.showNotification('Shipment created successfully', dictionary, currentLanguage)
                Window['history'].push('/customer/shipment',{shipmentUuid:response.data.content.shipmentUuid})
            } else {
                response.data.errors.map((error) => {
                    utilCommon.showNotification(error, dictionary, currentLanguage)
                })
            }
        })
        .catch((err) => {
            dispatch(commonActions.setLoader(false))
        });
};

export const createTLShipment = (dispatch, currentLanguage, dictionary, inputDTO) => {
    const source = axios.CancelToken.source();
    const params = {
        headers: authHeader(),
        cancelToken: source.token
    };
    const url = getApiUrl('quote', 'fcCreateTlShipment');

    dispatch(commonActions.setLoader(true))

    const request = axios.post(url, inputDTO, params)
        .then((response) => {
            dispatch(commonActions.setLoader(false))

            if (response.data.success === true) {
                getShipmentDetail(dispatch, {shipmentUuid: response.data.data.id}).then((shipmentDetailResponse) => {
                    const isBGShipment = !lodash.isEmpty(
                        lodash.get(shipmentDetailResponse, 'data.content.shipmentList.0.tlShipmentData.rateQuotes', [])
                    )

                    if (isBGShipment) {
                        Window['history'].push('/customer/tl-quote-results')
                    } else {
                        Window['history'].push('/customer/tl-shipment', {shipmentUuid: response.data.data.id})
                    }
                });

                utilCommon.showNotification('Shipment created successfully', dictionary, currentLanguage)
            } else {
                if (response.data.errors.length) {
                    response.data.errors.map((error) => {utilCommon.showNotification(error, dictionary, currentLanguage, false, 'error')})
                } else {
                    utilCommon.showNotification('Something went wrong during create shipment', dictionary, currentLanguage, false, 'error')
                }
            }
        })
        .catch((error) => {
            dispatch(commonActions.setLoader(false))

            if (!axios.isCancel(error)) {
                utilCommon.showNotification(
                    'Something went wrong during create shipment',
                    dictionary,
                    currentLanguage,
                    false,
                    'error'
                );
            }
        });

    return {
        request,
        cancelation: source
    };
};

export default {
    getQuotesMaster,
    getQuoteResults,
    getProducts,
    createShipment,
    fcCreateShipment,
    getCarriers,
    reRunQuote,
    fcReRunQuote,
    getAddresses,
    createTLShipment,
    cancelQuoteRequests
};


